import React, { useEffect, useRef } from "react";
import styled from "@emotion/styled";
import "../styles/styles.css";
import Cell from './MenuItemUnlimitedCell';
import { ThemeContext, UserContext } from "../contexts/Context";

const MenuItemUnlimitedScroll = ({
  height,
  width,
  sidebarWidth,
  headerHeight,
  selectedCategory,
  setSelectedMenu,
  setSelectedCategory,
  theme,
  selectedItems,
  addItemDirect,
  cart,
  removeFromCart,
  menuList,
  lanIndex,
  isLanReverse,
  isScrolling,
  lastPos,
  setLastPos,
  cp,
  menuSelectionFormRef,
  setScrollDown
}) => {
   const themeContext = React.useContext(ThemeContext);
  const { displayMenuDescription } = React.useContext(UserContext);
  
  const scrollPos = useRef(0);
  const scrolling = useRef(false);

  const catPos = useRef([]);

  const onscroll = (e) => {
    if (scrolling.current) return;

    if (!catPos.current || catPos.current.length == 0 || !catPos.current[0].category) return;
    let firstMenu = document.getElementById(catPos.current[0].category);
    if (firstMenu == null) return;

    let pos = firstMenu.getBoundingClientRect().top;
    let offset = pos - scrollPos.current;
    if (Math.abs(offset) < 160) return;
    scrollPos.current = pos;
    if (offset < 0) {//swipe up
      setScrollDown(true);
      //height
      for (let i = catPos.current.length - 1; i >= 0; i--) {
        if (catPos.current[i].pos + pos < height - 20) {
          let category = catPos.current[i].category.replaceAll("/", "");
          category = category.replaceAll("%", "");
          setSelectedCategory(catPos.current[i].cat);
          break;
        }
      }
    } else { //swipe down
      setScrollDown(false);
      for (let it of catPos.current) {
        if (it.pos + pos > 20) {
          let category = it.category.replaceAll("/", "");
          category = category.replaceAll("%", "");
          setSelectedCategory(it.cat);
          break;
        }
      }
    }


  }

  useEffect(() => {
    scrolling.current = isScrolling;
  }, [isScrolling]);


  const lazyLoad = () => {
    let lazyBg = document.querySelectorAll('.item-img');
    for (let bg of lazyBg) {
      const top = bg.getBoundingClientRect().top;
      if (top < window.innerHeight) {
        bg.style.backgroundImage = `url('${bg.dataset.bg}')`;
        bg.classList.remove('item-img');
      } else {
        break;
      }
    };
  }

  useEffect(() => {
    //preset each element position
    if (lastPos != 0) {
      // let currentPos = document.getElementById("menu_scroll").firstElementChild.getBoundingClientRect().top;
      // let offset = currentPos - lastPos;
      // document.getElementById("menu_scroll").scrollBy({ top: offset, behavior: "instant" });
      document.getElementById("menu_scroll").scrollTo({ top: lastPos, behavior: "instant" });
      window.setTimeout(() => {
        lazyLoad();
      }, 50);
    } else if (selectedCategory) {
      
      const menuScroll = document.getElementById("menu_scroll");
      const categoryElement = document.getElementById(selectedCategory.category);
      if (categoryElement) {
        const isFirstCategory = menuList.length > 0 && selectedCategory.category === menuList[0].category;
        const categoryTop = isFirstCategory ? 0 : categoryElement.getBoundingClientRect().top
          - menuScroll.getBoundingClientRect().top + menuScroll.scrollTop;
        menuScroll.scrollTo({ top: categoryTop, behavior: "instant" });
      }
      window.setTimeout(() => {
        lazyLoad();
      }, 50);
    }

    document.getElementById("menu_scroll").addEventListener('scroll', lazyLoad);
    document.getElementById("menu_scroll").addEventListener('resize', lazyLoad);
    document.getElementById("menu_scroll").addEventListener('scroll', onscroll);
    return () => {
      if (document.getElementById("menu_scroll") != null) {
        document.getElementById("menu_scroll").removeEventListener('scroll', onscroll);
        document.getElementById("menu_scroll").removeEventListener('scroll', lazyLoad);
        document.getElementById("menu_scroll").removeEventListener('resize', lazyLoad);
      }
    }
  }, []);

  useEffect(() => {
    let i = 0, fs = 0;
    catPos.current = [];
    for (let mn of menuList) {
      let el = document.getElementById(mn.category);
      if (el == null) continue;
      let pos = el.getBoundingClientRect().top;
      if (i == 0) {
        fs = pos;
      }

      catPos.current.push({ category: mn.category, pos: pos - fs, cat: mn });
      for (let sc of mn.type) {
        if (!sc.isCategory) continue;
        let el = document.getElementById(sc.category);
        let pos = el.getBoundingClientRect().top;
        catPos.current.push({ category: sc.category, pos: pos - fs, cat: sc });
      }
      i++;
    }
  }, [menuList]);

  const columnCount = width >= 768 ? 3 : (Number(cp) === 0 ? 1 : 2);
  const size3ColumnCount = width >= 768 ? 2 : 1;
  const menuWidth = width - sidebarWidth;
  const hasMobileSidebar = width < 768 && Number(cp) === 0;
  const desktopCardGap = Math.max(18, Math.min(34, Math.round(menuWidth * 0.025)));
  // Account for the card margins; sidebar cards use a tighter mobile margin.
  const cardInset = width >= 768 ? desktopCardGap + 16 : (hasMobileSidebar ? 14 : 18);
  const rowGap = width >= 768 ? desktopCardGap : (hasMobileSidebar ? 4 : 6);
  const getDisplaySize = (item) => width >= 768 && Number(item.size) === 1 ? 0 : Number(item.size || 0);
  const showDescription = displayMenuDescription === true || displayMenuDescription === "true";
  const hasDisplayedDescription = (menuItem) => {
    if (!menuItem || menuItem.isCategory) return false;
    const description = (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse)
      ? menuItem.description
      : (menuItem.description2 || menuItem.description);
    return typeof description === "string" && description.trim().length > 0;
  };
  const rowHasDescription = (items, index) => {
    if (!showDescription) return false;
    const rowStart = Math.floor(index / columnCount) * columnCount;
    return items.slice(rowStart, rowStart + columnCount).some(hasDisplayedDescription);
  };
  const getHeight = (lt, hasDescriptionInRow = false) => {
    const itemSize = getDisplaySize(lt);
    const cardWidth = menuWidth / columnCount - cardInset;
    const standardContentHeight = width >= 768
      ? (hasDescriptionInRow ? 178 : 136)
      : (hasDescriptionInRow ? (hasMobileSidebar ? 146 : 200) : (hasMobileSidebar ? 84 : 140));
    const size1ContentHeight = !hasDescriptionInRow && !hasMobileSidebar ? -60 : 0;
    if (!cp) {
      if (itemSize === 0) { //standard size
        return cardWidth + standardContentHeight;
      } else if (itemSize === 1) { //single size
        return (menuWidth + 12 + size1ContentHeight);
      } else if (itemSize === 2) { //pure text only
        return (96);
      } else if (itemSize === 3) {
        return hasDescriptionInRow ? (width >= 768 ? 176 : 172) : (width >= 768 ? 140 : 132);
      }
    } else {
      if (itemSize === 0) { //standard size
        return cardWidth + standardContentHeight;
      } else if (itemSize === 1) { //single size
        return (menuWidth + 12 + size1ContentHeight);
      } else if (itemSize === 2) { //pure text only
        return (96);
      } else if (itemSize === 3) {
        return hasDescriptionInRow ? (width >= 768 ? 176 : 172) : (width >= 768 ? 140 : 132);
      }
    }
  }
  //List Required Constants
  return (
    <MenuWrapper
      className="no-scrollbars"
      height={height - headerHeight}
      width={width}

    >
      {menuList && menuList.map((mn, i) =>
        <React.Fragment key={i}>
          <CategoryTitle id={mn.category} theme={themeContext}>
            {(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? mn.category : mn.category2}
          </CategoryTitle>
          <MenuItemWrapper>
            {mn.type.map((item, j) =>
              item.isCategory ?
                (
                  <React.Fragment key={"S" + j}>
                    <SubCategoryTitle id={item.category} width={menuWidth} theme={themeContext}>
                      {(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? item.category : item.category2}
                    </SubCategoryTitle>
                    {item.type.map((it, k) =>
                      it.codeId == "" ? "" :
                        <div style={{
                          width: getDisplaySize(it) === 3 ? menuWidth / size3ColumnCount : (getDisplaySize(it) === 0 ? menuWidth / columnCount : menuWidth),
                          height: "auto",
                          marginTop: rowGap,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                          <Cell
                            key={"" + i + k}
                            data={{
                              item: it,
                              setSelectedMenu,
                              setSelectedCategory,
                              theme,
                              selectedItems,
                              addItemDirect,
                              cart,
                              removeFromCart,
                              setLastPos,
                              cp,
                              menuSelectionFormRef
                            }}
                            columnIndex={i}
                            rowIndex={k}
                            containerWidth={getDisplaySize(it) === 3 ? menuWidth / size3ColumnCount - cardInset : (getDisplaySize(it) === 0 ? menuWidth / columnCount - cardInset : menuWidth - cardInset)}
                            containerHeight={getHeight(it, rowHasDescription(item.type, k))}
                          />
                        </div>
                    )}

                  </React.Fragment>
                )
                :
                (item.codeId == "" ? "" :
                  <div style={{
                    width: getDisplaySize(item) === 3 ? menuWidth / size3ColumnCount : (getDisplaySize(item) === 0 ? menuWidth / columnCount : menuWidth),
                    height: "auto",
                    marginTop: rowGap,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    <Cell
                      key={"" + i + j}
                      data={{
                        item,
                        setSelectedMenu,
                        setSelectedCategory,
                        theme,
                        selectedItems,
                        addItemDirect,
                        cart,
                        removeFromCart,
                        setLastPos,
                        catPos,
                        cp,
                        menuSelectionFormRef
                      }}
                      columnIndex={i}
                      rowIndex={j}
                      containerWidth={getDisplaySize(item) === 3 ? menuWidth / size3ColumnCount - cardInset : (getDisplaySize(item) === 0 ? menuWidth / columnCount - cardInset : menuWidth - cardInset)}
                      containerHeight={getHeight(item, rowHasDescription(mn.type, j))}
                    />
                  </div>
                )
            )}
          </MenuItemWrapper>
        </React.Fragment>
      )}
      <Buffer height={200} />
    </MenuWrapper>
  );
};
export default (MenuItemUnlimitedScroll);


const Buffer = styled.div`
  display: block;
  height: ${(props) => props.height}px;
`;

const MenuWrapper = styled.div`
 
`;
const CategoryTitle = styled.div`
  display: flex;
  margin-left: 16px;
  align-items: center;
  padding-top: 36px;
  font-size: 18px;
  font-weight: 700;
  color:${props => props.theme.primaryColor};
`;

const SubCategoryTitle = styled.div`
  display: flex;
  margin-left: 16px;
  align-items: center;
  padding-top: 32px;
  font-size: 14px;
  font-weight: 500;
  width: ${props => props.width}px;
  color:${props => props.theme.primaryColor};
`;

const MenuItemWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

